import Operation from "../index.js";

export default {
    //已上课
    findClassRecordByStu(params, fn) {
        Operation.Http.post(`/hm/findClassRecordByStu`, params, fn)
    },
    //修改学员资料
    saveStuSelfInfo(params, fn) {
        Operation.Http.post(`/hm/saveStuSelfInfo`, params, fn)
    },
}



// WEBPACK FOOTER //
// ./src/request/api/hm.js